export const isIterableArray = (array) => { return Array.isArray(array) && !!array.length; };
